export const stripePublishableKey =
  process.env.REACT_APP_ENV === "production"
    ? "pk_live_51HyiKMEGuiXMu7rLranL0qRyMPh2pR1X7fNhsxGpX4xHBBZREBlJr2wcAymVHRNyjtsWoqdjYDBPeHtEGehjLJ0C00EeL1jsiG"
    : "pk_test_51HyiKMEGuiXMu7rLwxVjVbqXE3mpRSa7LYYBFUh2b33ayuac6Wn9LtJcO9cylp3VXjApBGPMmK3yjhlNdQardpti00Y20oX39H";
